/* Copyright (c) 2021-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { InjectionToken } from '@angular/core';

export enum PerformanceMeasures {
    Read = 'Read',
    Write = 'Write',
    Remove = 'Remove',
    Cache = 'Cache'
}

// For Apps that need JSON file read, we enable the JSON file read flow eg: GFN native, override-tool native
// For Apps that don't need migration, we skip the migration flow eg: NvApp, override-tool
// For GFN apps, we need registerStorageChangeEvent to be true to listen to storage change events
// shouldPerformMigration - Enables migration flow for moving keys from sharedStorage.json file to IndexedDB.
// shouldPerformJSONFileRead - Enables flow for reading keys from sharedStorage.json.
// registerStorageChangeEvent - Determines whether to listen for any changes in sharedStorage.json (for CEF) or in IndexedDB (for browser multi-tab).
// keysToPersistInJSON - List of storage keys that should remain in sharedStorage.json and not be migrated to IndexedDB.
export class StorageConfig {
    keysToPersistInJSON?: string[];
    objectStoreName?: string; // Name of the object-store in IndexedDB (default: 'sharedStore' | 'global' for NvApp)
    shouldPerformMigration?: boolean; // Indicates whether to perform migration logic (default: false)
    shouldPerformJSONFileRead?: boolean; // Indicates whether to perform JSON file read logic (default: false)
    registerStorageChangeEvent?: boolean; // Indicates whether to listen to storage change events (default: false)
}

export enum MigrationState {
    NOT_ATTEMPTED = 'NOT_ATTEMPTED',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

export const STORAGE_CONFIG = new InjectionToken<StorageConfig>('StorageConfig');
